import React, { useState } from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import { GridActionsCellItem } from "@mui/x-data-grid"
import ActionIcon from "./ActionIcon"
import { Save } from "@mui/icons-material"

const DynamicElementEditAction = ({ isSaving, isSuccess, shouldShow }) => {
  if (!shouldShow) {
    return null
  }

  return (
    <GridActionsCellItem
      label=""
      className="edit-action-button"
      data-saving={isSaving || isSuccess}
      icon={
        <ActionIcon
          success={isSuccess}
          loading={isSaving}
          handleSubmit={() => {}}
          ActionComponent={Save}
          tooltipTitle={
            isSuccess
              ? i18n.t("dynamicElement.saved")
              : isSaving
                ? i18n.t("dynamicElement.saving")
                : i18n.t("dynamicElement.save")
          }
        />
      }
    />
  )
}

DynamicElementEditAction.propTypes = {
  isSaving: PropTypes.bool,
  isSuccess: PropTypes.bool,
  shouldShow: PropTypes.bool,
}

export default DynamicElementEditAction
